export function SkipLink() {
  return (
    <a href="#main-content" className="sr-only-focusable">
      Skip to main content
    </a>
  )
}
